import { ApiResponse } from '../../global-types';
import { AssetStorageResponse } from '../../global-types/images';
import { uploadPreviewToS3 } from '../../services/image';
import { S3Uploader } from '../../services/s3-upload';
import { dataUriToBlob } from '../utility/data-uri-to-blob';

/**
 * Uploads preview image to S3
 * Once finished uploading images, links assets
 *
 * @param assetStorageUrls A list of asset storage urls for each preview image
 * @param previewImage The preview image to upload
 * @param index The index of the preview image to upload
 * @returns Promise
 */
export const uploadPreviewImage = async (
  assetStorageUrls: ApiResponse<AssetStorageResponse>,
  previewImage: string,
  index: number,
  uploadFile: S3Uploader,
) => {
  const url = assetStorageUrls?.data?.[`${index}`];
  if (!url) {
    throw new Error('Missing asset storage URL for preview image');
  }
  await uploadPreviewToS3(prepareFormData(previewImage), url, uploadFile);
  return null;
};

// TODO: When MIMIR-3234 is finished, we can probably remove prepareFormData
/**
 * Create formData for S3 preview image upload
 *
 * @param saveData A list of card faces with printJson, which we use for printJson previews only
 * @returns void
 */
const prepareFormData = (image) => {
  const blob = dataUriToBlob(image);
  const formData = new FormData();
  if (blob) {
    formData.append('file', blob);
    formData.append('is_handwriting_image', `false`);
    formData.append('display_indicator', `false`);
  } else {
    throw new Error('Error generating preview blob');
  }
  return formData;
};
